import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {TransferItem} from 'ng-zorro-antd';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {DistributorsService, ProductsService} from '../../../services';
import {DocumentsService} from '../../../services/business/documents/documents.service';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {debounceTime, takeUntil} from 'rxjs/operators';

@Component({
  selector: 'assign-product',
  templateUrl: './assign-product.component.html',
  styleUrls: ['./assign-product.component.scss']
})
export class AssignProductComponent implements OnInit, OnDestroy {
  unsubscribe$ = new Subject<void>();

  isVisible = false;
  actions = [
    {label: 'Gán sản phẩm', value: 0},
    {label: 'Gỡ sản phẩm', value: 1},
    {label: 'Export', value: 2},
    {label: 'Export tất cả', value: 3},
  ];
  list: TransferItem[] = [];
  pageIndexLeft = 1;
  pageSizeLeft = 5;
  pageIndexRight = 1;
  pageSizeRight = 5;
  // tslint:disable-next-line:variable-name
  form_step: FormGroup = this.fb.group({
    title: [null, [Validators.required]],
    role: [null, [Validators.required]],

  });
  typeSubmit = false;
  listRole;
  listTitle;
  listOfAllData;
  total: number;
  ids;
  notDocuments = false;
  files: any[] = [];
  isLoadingBtn = false;

  @Input() businessIdChild: string;
  // @ts-ignore
  @ViewChild('tranferData') tranferData;
  // @ts-ignore
  @ViewChild('selectDocument') selectDocument;
  @Output() loadDataParent = new EventEmitter();
  searchChange$ = new BehaviorSubject('');
  searchChangeRight$ = new BehaviorSubject('');
  // @ts-ignore
  @ViewChild('create') create;

  constructor(
    private fb: FormBuilder,
    private notification: NzNotificationService,
    private distributorsService: DistributorsService,
    private productService: ProductsService,
    private docService: DocumentsService,
  ) {
    /*Search Tranfer*/
    /* search left*/
    const optionList$: Observable<string> = this.searchChange$
      .asObservable()
      .pipe(debounceTime(500));

    optionList$.pipe(takeUntil(this.unsubscribe$)).subscribe(value => {
      if (this.form_step.get('role').value) {
        if (value && value.trim().length > 0) {
          this.pageIndexLeft = 1;
          this.tranferData.changePageIndexLeft(this.pageIndexLeft);

          const query = {
            businessId: this.businessIdChild,
            roleCode: this.form_step.get('role').value,
            page: this.pageIndexLeft,
            page_size: this.pageSizeLeft,
            name: value.trim()
          };
          this.distributorsService.listProductTranfer(query).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
            this.tranferData.listLeft(res);
          });
        } else {
          this.pageIndexLeft = 1;
          this.tranferData.changePageIndexLeft(this.pageIndexLeft);
          this.listProductLeft();
        }
      }
    });

    /* search right*/
    const optionListRight$: Observable<string> = this.searchChangeRight$
      .asObservable()
      .pipe(debounceTime(500));

    optionListRight$.pipe(takeUntil(this.unsubscribe$)).subscribe(value => {
      if (this.form_step.get('role').value) {
        if (value && value.trim().length > 0) {
          this.pageIndexRight = 1;
          this.tranferData.changePageIndexRight(this.pageIndexRight);
          const query = {
            businessId: this.businessIdChild,
            roleCode: this.form_step.get('role').value,
            page: this.pageIndexRight,
            page_size: this.pageSizeRight,
            ids: this.ids.toString(),
            name: value.trim()

          };
          this.distributorsService.listProductTranfer(query).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
            this.tranferData.listRight(res);
          });
        } else {
          if (this.ids.length > 0) {
            this.pageIndexRight = 1;
            this.tranferData.changePageIndexRight(this.pageIndexRight);
            this.listProductRight();
          }
        }
      }
    });

    /*End Search Tranfer*/

  }

  ngOnInit() {
    this.notification.config({
      nzPlacement: 'bottomRight'
    });

    this.distributorsService.listRole().pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      this.listRole = res.data;

    });

  }

  roleChange($event: any) {
    this.listTitle = null;
    this.form_step.get('title').setValue(null);
    if ($event) {
      this.listProductLeft();
      this.distributorsService.listTitle({roleCode: $event}).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
        this.listTitle = res.data;
      });
    }
  }


  showModal(): void {
    this.isVisible = true;
  }

  handleCancel(): void {
    this.isVisible = false;
    this.typeSubmit = false;
    this.files = [];
    this.ids = '';
    this.form_step.reset();
  }

  onSubmit() {
    this.typeSubmit = true;
    const recursive = (f: FormGroup | FormArray) => {
      // tslint:disable-next-line:forin
      for (const i in f.controls) {
        if (typeof f.controls[i].value === 'string') {
          if (f.controls[i].value.trim().length === 0) {
            f.controls[i].value = null;
          }
        }
        if (f.controls[i] instanceof FormControl) {
          f.controls[i].markAsDirty();
          f.controls[i].updateValueAndValidity();
        } else {
          recursive(f.controls[i] as any);
        }
      }
    };

    const form = this.form_step;
    recursive(form);

    if (form.invalid) {
      return;
    }


    if (this.ids === undefined || this.ids.length === 0) {
      return;
    }

    if (this.files.length === 0) {
      this.notDocuments = true;
      return;
    }
    const docs = [];
    this.files.map(item => {
      docs.push(item.documentId);
    });

    const body = {
      titleId: this.form_step.get('title').value,
      documents: docs,
      assignProduct: this.ids,
      businessId: this.businessIdChild,
      roleCode: this.form_step.get('role').value
    };
    this.isLoadingBtn = true;
    this.distributorsService.addProduct(body).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      if (res.code === 1) {
        this.notification.create(
          'success',
          'Thành công',
          'Thêm sản phẩm thành công'
        );
        this.loadDataParent.emit(true);
        this.handleCancel();
      } else {
        this.notification.create(
          'warning',
          'Cảnh báo',
          res.message
        );
      }
      this.isLoadingBtn = false;

    }, (err) => {
      this.notification.create(
        'error',
        'Thất bại',
        err
      );
      this.isLoadingBtn = false;
    });
  }

  /*document*/
  newDocument(event) {
    this.docService.create(event).subscribe(
      res => {
        if (res.code === 1) {
          this.create.hide();
          this.files.push(res.data);
          this.notDocuments = false;
          this.files.map((item) => {
            this.selectDocument.setId(item.documentId, true);
          });
          this.notification.create(
            'success',
            'Thêm giấy tờ thành công',
            res.message
          );
        } else {
          this.notification.create(
            'error',
            'Thêm giấy tờ thất bại',
            res.message
          );
        }
      },
      error => {
        this.notification.create(
          'error',
          'Thêm giấy tờ thất bại',
          error
        );
      }
    );
    // this.files.push(event.data);
    // this.notDocuments = false;
    // this.files.map((res) => {
    //   this.selectDocument.setId(res.documentId, true);
    // });

  }

  delete(file, index) {
    this.selectDocument.setId(this.files[index].documentId, false);
    this.files.splice(index, 1);
    if (!this.files.length) {
      this.notDocuments = true;
    }

  }

  modalDocument() {
    this.selectDocument.setCheckboxAll();
    this.files.map((res) => {
      this.selectDocument.setId(res.documentId, true);
    });
    this.selectDocument.showModal();
  }

  selectDocuments(event) {
    this.notDocuments = event.ids.length === 0;
    const newList = [];
    event.ids.map((item, key) => {
      const data = {
        documentId: item,
        title: event.titles[key]
      };
      newList.push(data);
    });
    this.files = newList;
    this.selectDocument.handleCancel();

  }

  /*End document*/

  /*Tranfer*/
  listProductLeft() {
    const query = {
      businessId: this.businessIdChild,
      roleCode: this.form_step.get('role').value,
      page: this.pageIndexLeft,
      page_size: this.pageSizeLeft,
    };
    this.distributorsService.listProductTranfer(query).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      this.tranferData.listLeft(res);
    });
  }


  paginateLeftFun($event: any) {
    this.pageIndexLeft = $event.page;
    this.pageSizeLeft = $event.page_size;
    this.listProductLeft();
  }

  paginateRightFun($event: any) {
    this.pageIndexRight = $event.page;
    this.pageSizeRight = $event.page_size;
    this.listProductRight();
  }

  /*click chuyển data sang form phải*/
  emitDataLeftFun($event: any) {
    this.ids = $event;
    if ($event.length !== 0) {
      const query = {
        businessId: this.businessIdChild,
        roleCode: this.form_step.get('role').value,
        page: this.pageIndexRight,
        page_size: this.pageSizeRight,
        ids: $event.toString(),
      };
      this.distributorsService.listProductTranfer(query).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
        this.tranferData.listRight(res);

        if (res.items.length === 0 && this.pageIndexRight > 1) {
          this.pageIndexRight = this.pageIndexRight - 1;
          this.tranferData.changePageIndexRight(this.pageIndexRight);

          const query2 = {
            businessId: this.businessIdChild,
            roleCode: this.form_step.get('role').value,
            page: this.pageIndexRight,
            page_size: this.pageSizeRight,
            ids: $event.toString(),
            // not_in: this.notInRight ? this.notInRight : ''
          };
          this.distributorsService.listProductTranfer(query2).pipe(takeUntil(this.unsubscribe$)).subscribe((res2) => {
            this.tranferData.listRight(res2);
          });
        }
      });
    } else {
      this.tranferData.listRight('null');
    }

  }

  listProductRight() {
    const query = {
      businessId: this.businessIdChild,
      roleCode: this.form_step.get('role').value,
      page: this.pageIndexRight,
      page_size: this.pageSizeRight,
      ids: this.ids.toString(),
    };
    this.distributorsService.listProductTranfer(query).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      this.tranferData.listRight(res);
    });
  }


  searchLeft($event: any) {
    this.searchChange$.next($event.event);
  }

  searchRight($event: any) {
    this.searchChangeRight$.next($event.event);
  }

  /*EndTranfer*/

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
